import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { BRAND, METHOD_FLOW, PRODUCT } from '../data/content';
export function WhatIsSection() {
  return <section aria-labelledby="que-es" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-210" data-mp="2cmzfu2jah71g">
      <Reveal data-id="element-211" data-mp="1kv1ftz2xupg3">
        <SectionHeading id="que-es" title={`¿Qué es ${PRODUCT}?`} data-id="element-212" data-mp="1kvba3yv0nirl" />
      </Reveal>

      <Reveal delay={0.05} className="mx-auto mt-6 max-w-3xl" data-id="element-213" data-mp="1own0w7pmma1d">
        <p className="text-base md:text-lg leading-relaxed text-ink-muted" data-id="element-214" data-mp="1ox52ljv25ggo">
          Es una biblioteca digital creada por {BRAND} para personas que quieren
          comprender mejor la Biblia sin sentirse perdidas entre libros,
          personajes, contextos y pasajes difíciles.
        </p>
        <p className="mt-4 text-base md:text-lg leading-relaxed text-ink-muted" data-id="element-215" data-mp="35ad5dfknr0bj">
          Vas a encontrar explicaciones claras, recursos visuales, reflexiones y
          un método práctico para estudiar paso a paso.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-2" data-id="element-216" data-mp="ge5h6ooxw245">
        {METHOD_FLOW.map((step, i) => <React.Fragment key={step} data-id="element-217" data-mp="bh5cah3tt5em" data-mpi={i}>
            <span className="rounded-full border border-lineStrong bg-surface px-5 py-2 font-sans text-sm font-bold uppercase tracking-[0.12em] text-ink" data-id="element-218" data-mp="6ghd385g1i9b">
              {step}
            </span>
            {i < METHOD_FLOW.length - 1 && <ChevronRightIcon size={16} aria-hidden="true" className="text-gold-bright" data-id="element-219" data-mp="3su95mlqmie2p" />}
          </React.Fragment>)}
      </Reveal>

      <Reveal delay={0.14} data-id="element-220" data-mp="3jsrjomqjbi63">
        <p className="mt-8 font-script text-3xl md:text-4xl text-gold" data-id="element-221" data-mp="3evhrx0foauf3">
          Tu tiempo con Dios cambia todo
        </p>
      </Reveal>
    </section>;
}